// extracted by mini-css-extract-plugin
export default {"giving-report-date-range":"styles__giving-report-date-range____6fAn","half-width-left":"styles__half-width-left___VZZAU","readOnly":"styles__readOnly____zr_b"};